export type ValueConverter = (value: any) => any;

export const defaultConverter: ValueConverter = (value: any) => value;

export const dateConverter: ValueConverter = (value: any) => {
  if (!value) {
    return value;
  }
  return value instanceof Date ? value : new Date(value);
};
